import { gql } from '@apollo/client';
import React from 'react';
import Card from '../components/Card';
import type { ActivityCommentCard_CommentFragment } from '../graphql/generated/graphqlTypes';
import CommentPreview from '../post/comment/CommentPreview';
import commentThreadPath from '../utils/url/commentThreadPath';

const ACTIVITY_COMMENT_CARD_COMMENT = gql`
  fragment ActivityCommentCard_comment on Comment {
    id
    content
    thread {
      id
      ...commentThreadPath_thread
    }
  }
  ${commentThreadPath.fragments.thread}
`;

interface ActivityCommentCardProps {
  comment: ActivityCommentCard_CommentFragment;
}

const ActivityCommentCard = ({ comment }: ActivityCommentCardProps) => {
  const { thread, content } = comment;
  const threadPath = thread ? commentThreadPath(thread) : null;
  return (
    <Card ignoreInsideLinks to={threadPath ?? undefined}>
      <CommentPreview content={content} maxLines={8} />
    </Card>
  );
};

ActivityCommentCard.fragments = { comment: ACTIVITY_COMMENT_CARD_COMMENT };

export default ActivityCommentCard;
